import React from "react";
import BallCanvas from "../shader/Ball";

const TechBall = (props) => {
  return (
    <div className="w-28 h-28">
      <BallCanvas icon={props.icon} />
    </div>
  );
};

export default TechBall;
